import Tooltip from "react-bootstrap/Tooltip";

export const TooltipTravelTime = (props) => (
    <Tooltip id="dynamic-include-tooltip" className="info-tooltip" {...props}>
        Se aplicara un tiempo fijo de desplazamiento entre puntos previo al calculo de la ruta de 5 minutos.
        Una vez calculada la ruta, se utilizará el tiempo de desplazamiento estimado por el motor de navegación entre cada uno de los puntos.
    </Tooltip>
)